import React from 'react';
import AboutBanner from '../component/AboutComponent/AboutBanner';
import MyAccount from '../component/MyAccount';

const Form = () => {
    return (
        <div>
            <AboutBanner/>
            <MyAccount></MyAccount>
            
        </div>
    );
};

export default Form;